import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { ProviderAuthenticationCompletion } from "../../../../views/auth/ProviderAuthenticationCompletion/ProviderAuthenticationCompletion";

function ProviderAuthenticationCompletionRoute() {
  const { code } = Route.useSearch();
  const [completionCode] = useState(code);
  return <ProviderAuthenticationCompletion code={completionCode} />;
}

export const Route = createFileRoute("/_public/auth/provider/complete")({
  component: ProviderAuthenticationCompletionRoute,
  validateSearch: (search: Record<string, unknown>) => ({
    code:
      typeof search.code === "string" && search.code.length > 0
        ? search.code
        : undefined,
  }),
  staticData: {
    routeKey: "providerAuthenticationComplete",
    access: "public-auth",
    layout: "modern",
    container: "default",
  },
});
